<template>
  <div class="bg-white flex items-center h-screen w-full">
    <side-nav :sideNavOpen="showSideNav" @closeSideNav="toggleSideNav" />
    <div class="h-full flex duration-200 flex-1 flex-col self-stretch">
      <nav-bar @selectedModuleChange="onSelectedModuleChange" />
      <main class="flex-1 w-full overflow-y-auto">
        <router-view></router-view>
      </main>
    </div>
  </div>
</template>

<script lang="ts">
import SideNav from '@/components/home/SideNav.vue';
import NavBar from '@/components/home/NavBar.vue';

import { Vue, Options } from 'vue-class-component';

@Options({
  components: {
    SideNav,
    NavBar
  }
})
export default class HomeLayout extends Vue {
  public showSideNav: boolean = true;

  public toggleSideNav() {
    this.showSideNav = !this.showSideNav;
  }

  public onSelectedModuleChange(val: any) {
    this.$emit('selectedModuleChange', val);
  }
}
</script>
